// Copied from https://k2-calculator-api.developer.azure-api.net/api-details#api=api-dev&operation=post-partslist
const K2PartsList = [
  {
    partNumber: '4000143',
    description: "SPO CrossRail 44-X 86'', Mill",
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000719',
    description: 'CrossRail 44-X 172", Mill',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000720',
    description: 'CrossRail 44-X 172", Dark',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000721',
    description: 'CrossRail 44-X 185", Mill',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000722',
    description: 'CrossRail 44-X 185", Dark',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000723',
    description: 'CrossRail 48-X 172", Mill',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '-',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000724',
    description: 'CrossRail 48-X 172", Dark',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '-',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000727',
    description: 'CrossRail 48-XL 172", Mill',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '-',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000728',
    description: 'CrossRail 48-XL 172", Dark',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '-',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000176',
    description: 'End Cap 44-X , K2',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000177',
    description: 'Sleeve CR 44-X',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000583',
    description: 'CrossRail 3" Black Sleeve 48-X,48-XL',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000431',
    description: 'CrossRail Flat EndCap, CR 48-X,48-XL',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000122',
    description: '13x25mm Bonding T-Bolt Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Hardware',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000048',
    description: '13x25mm T-Bolt Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Hardware',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000629-H',
    description: 'CR Micro inverter & OPT, 13mm Hex Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Micro & Opt',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000083',
    description: 'MLPE, Module Frame Mount, Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Micro & Opt',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4005394',
    description: 'Wire Management Clip, Omega, Black',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000069',
    description: 'Wire Management Clip, TC',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000386',
    description: 'RailConn CR 48-X,48-XL Struct Set, Dark',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000385',
    description: 'RailConn CR 48-X,48-XL Struct Set, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4001196',
    description: 'Rail Connector UL 2703 Set, CR80, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000050-B',
    description: 'Yeti Clamp 2.0, Set',
    mountingSolution: 'CrossRail',
    category: 'Clamps',
    subCategory: 'End Clamp',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000170',
    description: 'Lag Screw 5/16 x 3" SS, W/ EPDM Washer',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000359',
    description: 'Lag Screw D145/16 x 4" SS',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000358',
    description: 'Lag Screw D145/16 x 4" SS w/ Washer',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000260',
    description: 'Lag Screw D145/16 x 4.5" SS',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000631',
    description: 'L-Foot Slotted Set, Dark',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000630',
    description: 'L-Foot Slotted Set, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000157',
    description: 'K2 Flash Comp Kit, Dark',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000156',
    description: 'K2 Flash Comp Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000115',
    description: 'Splice Foot Screw, M5x60',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Comp',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000113',
    description: 'Splice Foot X Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000265',
    description: 'Splice Foot Lift, Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000211',
    description: 'K2 Conduit Clamp Flashing Kit w/EverSeal',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000272',
    description: 'K2 Conduit Clamp Kit, w/EverSeal',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000279',
    description: 'K2 Conduit Clamp CrossRail Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000016',
    description: 'Standing Seam PowerClamp Mini, Set',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Standing Seam',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000017',
    description: 'Standing Seam PowerClamp Standard, Set',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Standing Seam',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000130',
    description: 'EverFlash Flat Tile – R, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000131',
    description: 'EverFlash S Tile – R, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000132',
    description: 'EverFlash W Tile – R, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000141-B',
    description: 'Flat Tile Hook X Kit, w/Butyl',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000141',
    description: 'Flat Tile Hook X, Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000008',
    description: 'K2 Tile Hood Flashing, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000140',
    description: 'Universal  Standard Hook, 9" Base, Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000142',
    description: 'Universal Standard Hook+2, 5.5" Base Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000142-B',
    description: 'USH +2, 5.5" Base Kit, w/Butyl',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000140-B',
    description: 'USH, 9", Base Kit, w/Butyl',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4001294',
    description: 'Tile Hook 3S Wide Base w/ Hardware',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000149',
    description: 'Solar Fastener 8mm, length 85 mm',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000167',
    description: 'Solar Fastener 8mm, length 155 mm',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000308',
    description: 'Trapezoidal PowerClamp, Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Trapezoidal',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000307',
    description: 'Corrugated PowerClamp, Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Corrugated',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000080',
    description: 'T-Foot X 6” Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Concrete',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000218',
    description: 'Big Foot 6" w/ 3"+ Chem Link Clip',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Concrete',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: 'ThirdPartyAttachment',
    description: 'Third Party Attachment',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'thirdParty',
  },
  {
    partNumber: '4000310',
    description: 'DR #14 x 3" x 5/16 Hex Head Screw',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000145',
    description: 'K2 Cross Clamp Set, Dark',
    mountingSolution: 'CrossRail',
    category: 'Clamps',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000312',
    description: 'K2 Cross Cap',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000135',
    description: 'K2 Cross Clamp Set, Mill',
    mountingSolution: 'CrossRail',
    category: 'Clamps',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000400',
    description: 'K2 4 Wire Dragon Clip, Set',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000006-H',
    description: 'K2 Ground Lug, 13mm Hex Set',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Bonding',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000382',
    description: 'HEYClip SunRunner Cable Clip SS, S6404',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000282',
    description: 'K2 Multi Mount Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000284',
    description: 'K2 Multi Mount Kit, Dark',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000051-T',
    description: 'Tool-less Rail Connector 44-X, Set, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000052-T',
    description: 'Tool-less Rail Connector 44-X, Set, Dark',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000559',
    description: 'K2 Armor w/Big Foot, Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000165',
    description: 'Splice Foot XL #14 Kit, Dark',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000300',
    description: 'Splice Foot XL #14 Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000458',
    description: 'K2 Edge, Module Clamp',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000460',
    description: 'K2 Edge, Connector',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000459',
    description: 'K2 Edge, 10 ft Dark Plastic',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000461',
    description: 'K2 Edge, Corner',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000770',
    description: 'K2 Runner Kit, Mill',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Hardware',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000769',
    description: 'K2 Runner Kit, Dark',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Hardware',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000237',
    description: 'K2 Drop N Lock Post 4.5", Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000238',
    description: 'K2 Drop N Lock Post 6", Kit',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000234',
    description: 'Drop N Lock RT - Flat, Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000235',
    description: 'Drop N Lock RT- S, Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000236',
    description: 'Drop N Lock RT - W, Kit',
    mountingSolution: 'CrossRail',
    category: 'Accessories',
    subCategory: 'Tile',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: 'multimountPlusk2runnerMill',
    description: 'Multi Mount + K2 Runner, Mill',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: 'multimountPlusk2runnerDark',
    description: 'Multi Mount + K2 Runner, Dark',
    mountingSolution: 'CrossRail',
    category: 'Attachments',
    subCategory: 'Comp',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000819',
    description: "CrossRail 44-X Max, 172'', Mill",
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000820',
    description: 'CrossRail 44-X Max, 172", Dark',
    mountingSolution: 'CrossRail',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000719',
    description: "CrossRail 44-X 172'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000143',
    description: "CrossRail 44-X 86'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000723',
    description: "CrossRail 48-X 172'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000727',
    description: "CrossRail 48-XL 172'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000144',
    description: "SPO CrossRail 44-X 86'', Dark",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000721',
    description: "CrossRail 44-X 185'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000722',
    description: "SPO CrossRail 44-X 185'', Dark",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000728',
    description: "CrossRail 48-XL 172'', Dark",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000724',
    description: "CrossRail 48-X 172'', Dark",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000720',
    description: "CrossRail 44-X 172'', Dark",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000050-B',
    description: 'Yeti Clamp 2.0, Set',
    mountingSolution: 'SimpleTilt',
    category: 'Clamps',
    subCategory: 'End Clamp',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000145',
    description: 'K2 Cross Clamp Set, Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Clamps',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000135',
    description: 'K2 Cross Clamp Set, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Clamps',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000416',
    description: 'Simple Tilt Knee, Set',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'All',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000559',
    description: 'K2 Armor w/Big Foot, Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000218',
    description: 'Big Foot 6” w/ 3”+ Chem Link Clip, Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000564',
    description: 'K2 Armor 3" Drop N Lock, Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000284',
    description: 'K2 Multi Mount Kit, Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000631',
    description: 'L-Foot Slotted Set, Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000080',
    description: 'T-Foot X 6" Kit, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000167',
    description: 'Solar Fastener 8mm, length 155 mm',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000149',
    description: 'Solar Fastener 8mm, length 85 mm',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: 'ThirdPartyAttachment',
    description: 'Third Party Attachment',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'Fastener',
    finish: '',
    partStatus: 'thirdParty',
  },
  {
    partNumber: '4000237',
    description: 'K2 Drop N Lock Post 4.5", Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000630',
    description: 'L-Foot Slotted Set, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000238',
    description: 'K2 Drop N Lock Post 6", Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000282',
    description: 'K2 Multi Mount Kit, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Attachments',
    subCategory: 'All',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000176',
    description: 'End Cap 44-X , K2',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000431',
    description: 'CrossRail Flat EndCap, CR 48-X,48-XL',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Rail',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000006-H',
    description: 'K2 Ground Lug Set',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Bonding',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000400',
    description: 'K2 4 Wire Dragon Clip, Set',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000629-H',
    description: 'CR Micro inverter & OPT, 13mm Hex Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Micro & Opt',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000382',
    description: 'HEYClip SunRunner Cable Clip SS, S6404',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000312',
    description: 'K2 Cross Cap',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'All',
    finish: 'All',
    partStatus: 'available',
  },
  {
    partNumber: '4000083',
    description: 'MLPE, Module Frame Mount, Kit',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Micro & Opt',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000069',
    description: 'Wire Management Clip, TC',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4005394',
    description: 'Wire Management Clip, Omega, Black',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Wire Management',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000358',
    description: 'Lag Screw D145/16 x 4" SS w/ Washer',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Hardware',
    finish: '',
    partStatus: 'available',
  },
  {
    partNumber: '4000051-T',
    description: 'Tool-less Rail Connector 44-X, Set, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000052-T',
    description: 'Tool-less Rail Connector 44-X, Set, Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000385',
    description: 'RailConn CR 48-X,48-XL Struct Set, Mill',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000386',
    description: 'RailConn CR 48-X,48-XL Struct Set, Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Accessories',
    subCategory: 'Connector',
    finish: 'Dark',
    partStatus: 'available',
  },
  {
    partNumber: '4000819',
    description: "CrossRail 44-X Max, 172'', Mill",
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Mill',
    partStatus: 'available',
  },
  {
    partNumber: '4000820',
    description: 'CrossRail 44-X Max, 172", Dark',
    mountingSolution: 'SimpleTilt',
    category: 'Rail',
    subCategory: '',
    finish: 'Dark',
    partStatus: 'available',
  },
]

export const K2PartsMap = Object.fromEntries(K2PartsList.map((part) => [part.partNumber, part.description]))
